import React from 'react'
import { BellIcon } from '../../../Icons/BellIcon'

const L2L3Banner = () => {
  return (
    <div className="purpleHeader">
      <div className="outerouter">
        <BellIcon />
        <div className="myStuff">
          <h4 className="stuffH2 ">
            Level 2 and Level 3 card data processing is currently supported in
            the US.
          </h4>
        </div>
      </div>
    </div>
  )
}

export default L2L3Banner
